import React from 'react';
import { Instagram } from 'lucide-react';
import { socialMedia } from '../mock/mockData';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="photo-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl font-semibold mb-4">Franziska Daum</h3>
            <p className="body-text text-gray-600">
              Hobby-Fotografin aus Deutschland
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body font-semibold mb-4 uppercase text-sm tracking-wider">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/" className="body-text text-gray-600 hover:text-primary transition-colors">Home</a></li>
              <li><a href="/galerie" className="body-text text-gray-600 hover:text-primary transition-colors">Galerie</a></li>
              <li><a href="/services" className="body-text text-gray-600 hover:text-primary transition-colors">Services</a></li>
              <li><a href="/kontakt" className="body-text text-gray-600 hover:text-primary transition-colors">Kontakt</a></li>
              <li><a href="/bewertung-abgeben" className="body-text text-gray-600 hover:text-primary transition-colors">Bewertung abgeben</a></li>
              <li><a href="/impressum" className="body-text text-gray-600 hover:text-primary transition-colors" data-testid="footer-impressum-link">Impressum</a></li>
              <li><a href="/datenschutz" className="body-text text-gray-600 hover:text-primary transition-colors" data-testid="footer-datenschutz-link">Datenschutz</a></li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="font-body font-semibold mb-4 uppercase text-sm tracking-wider">Folgen Sie Mir</h4>
            <div className="flex gap-4">
              <a 
                href={socialMedia.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full hover:border-primary hover:bg-primary hover:text-white transition-all"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-200 text-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Franziska Daum Photography. Alle Rechte vorbehalten.
          </p>
          <p className="text-xs text-gray-400 mt-2">
            Alle Bilder sind urheberrechtlich geschützt und mit Wasserzeichen versehen.
          </p>
          <p className="text-xs text-gray-400 mt-1" data-testid="footer-kleinunternehmer-note">
            Kleinunternehmerin gemäß § 19 UStG – Umsatzsteuer wird nicht ausgewiesen.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
